import Interpreter from 'js-interpreter';

export class Language {
    static ASYNC_METHODS = ["wait"];
    wait(seconds, callback) {
        console.log("wait (" + seconds + ")...");
        setTimeout(callback, seconds * 1000);
    }
}

export class Engine {
    constructor(prototypeClass) {

        const language = {};
        const parentClass = Object.getPrototypeOf(prototypeClass).prototype;
        const parentMethods = parentClass ? Object.getOwnPropertyNames(parentClass).filter((m) => {
            return m != "constructor"
        }) : [];
        const languageMethods = Object.getOwnPropertyNames(prototypeClass.prototype).filter((m) => {
            return m != "constructor"
        })
        const asyncParentMethods = parentClass ? parentClass.constructor.ASYNC_METHODS : [];
        const asyncMethods = asyncParentMethods.concat(prototypeClass.ASYNC_METHODS ? prototypeClass.ASYNC_METHODS : []);
        for (let method of parentMethods.concat(languageMethods)) {
            language[method] = {
                wrapper: prototypeClass.prototype[method],
                isAsync: asyncMethods.includes(method)
            }
        }

        this.api = function (interpreter, globalObject) {
            for (let f in language) {
                if (language[f].isAsync) {
                    interpreter.setProperty(globalObject, f,
                        interpreter.createAsyncFunction(language[f].wrapper));
                } else {
                    interpreter.setProperty(globalObject, f,
                        interpreter.createNativeFunction(language[f].wrapper));

                }
            }
            var wrapper = function lib(libraryFilename, callback) {
                var reg = /^[a-z]+$/i;
                if (!reg.test(libraryFilename)) {
                    console.log("library name not valid")
                    callback();
                    return
                }

                fetch('../levels/' + libraryFilename + '.js').then((result) => {
                    return result.text()
                  }).then((data) => {
                    interpreter.appendCode(data);
                    callback();
                  }).catch((error) => {
                      console.log("library not found:" + error);
                      callback();
                  })
              };
              interpreter.setProperty(globalObject, 'import',
                  interpreter.createAsyncFunction(wrapper));
        }
        this.running = [];
    }

    isRunning() {
        return this.running.length > 0
    }

    stop(reason) {
        while (this.running.length > 0) {
            const interpreter = this.running.pop();
            interpreter.isRunning = false;
            interpreter.stopReason = reason;
        }
    }
/* TODO
    runMany(codes, callback) {
        var toBeExecuted = codes.length;
        function partialCallback() {
            toBeExecuted--;
            if (toBeExecuted <= 0) {
                if (callback)
                    callback();
            }
        }

        for (let code of codes) {
            this.run(code, partialCallback);
        }
    }
*/
    run(code, callback) {

        var myInterpreter = null;
        try {
            myInterpreter = new Interpreter(code, this.api);
        } catch (error) {
            if (callback)
                callback('init-error', error.message);

            return;
        }

        myInterpreter.isRunning = true;

        this.running.push(myInterpreter);

        const runner = function () {
            if (myInterpreter.isRunning) {
                var hasError = null;
                var hasMore = false;
                try {
                    hasMore = myInterpreter.run();
                } catch (error) {
                    hasError = error.message;
                }

                if (hasMore) {
                    // Execution is currently blocked by some async call.
                    // Try again later.
                    setTimeout(runner, 1);
                } else {
                    // Program is complete.

                    myInterpreter.isRunning = false;
                    if (callback)
                        callback(hasError? 'runtime-error': 'completed', hasError);
                }
            } else {
                if (callback)
                    callback('stopped', myInterpreter.stopReason);
            }
        }.bind(this);
        runner();

    }
}


